/**
 * A company owned by another, in words (decision 7501; T3102): the Owned By
 * line, the Add Owner and End Ownership windows, the Subsidiaries tile's Past
 * heading and the two History labels, spread into the one lookup in
 * `strings.ts`. 🔨 This file imports nothing, because the lookup imports it.
 */
export const COMPANY_OWNERSHIP_STRINGS = {
  'recordPage.company.ownedBy': 'Owned By',
  'recordPage.company.ownedByNone': 'None yet',
  'ownership.add': '+ Add Owner',
  'ownership.addTitle': 'Add Owner',
  'ownership.addSubtitle': 'The company that owns {company}, the share it holds and the day it began.',
  'ownership.field.owner': 'Owning company',
  'ownership.field.ownerEntity': 'Company',
  'ownership.field.percent': 'Percent owned',
  'ownership.field.percentHint': 'Optional. Leave it empty when the share is not known.',
  'ownership.field.startDate': 'Start date',
  'ownership.end': 'End Ownership',
  'ownership.endSubtitle': '{owner} has owned {owned} since {date}.',
  'ownership.field.lastDay': 'Last day owned',
  'ownership.endConsequence': 'The ownership closes on the last day above and stays on both companies as history. Owning the company again is a new ownership, not an undo.',
  'ownership.past': 'Past',
  'ownership.since': 'since',
  'history.audit.ownershipAdded': 'Ownership added',
  'history.audit.ownershipEnded': 'Ownership ended',
} as const;
